const periodicityOptions = [
  {
    value: 1,
    label: 'Mensal',
  },
  {
    value: 2,
    label: 'Bimestral',
  },
  {
    value: 3,
    label: 'Trimestral',
  },
  {
    value: 4,
    label: 'Quadrimestral',
  },
  {
    value: 6,
    label: 'Semestral',
  },
  {
    value: 12,
    label: 'Anual',
  },
  {
    value: 24,
    label: 'Bienal',
  },
]

export default periodicityOptions
